import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../../TimeModal/TimeModalContext';
import { normalizeDate } from '../../../Utils/GlobalUtils';

import Loading from '../../Loading';

import FileUploadField from '../../FileUploadField';

import styles from '../../../styles/DynamicModal.module.css';

import IconContainer from '../../IconContainer';
import { ReactComponent as XIcon } from '../../../icons/x-close.svg';

const EditAccounting = ({ closeModal, id, action, caseId, onSuccess }) => {
    const { openTimeModal } = useTimeModal();

    const [formInfo, setFormInfo] = React.useState({
        id: '',
        case_id: '',
        date: '',
        comment: '',
        report: '',
        created_at: '',
        status: '',
    });
    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }

    React.useEffect(() => {
        if (action=='change') {
            const token = localStorage.getItem('token');
            if (!token) handleLogout();
            setStatus(<a><Loading type='inline' /></a>);

            axios.get(`/api/get-single-report?id=${id}`)
            .then((response) => {
                setFormInfo(response.data);
                setStatus(null);
            }).catch((error) => {
                console.error(error);
                setStatus(<a className='mainLabelError'>Не удалось загрузить данные. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            })
        } else {
            setLoading(false);
        }
    }, [])

    const handleChange = (field) => (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        setFormInfo((prev) => ({ ...prev, [field]: value }));

        setStatus('Сохраните изменения');

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };

    const [errorsForm, setErrorsForm] = React.useState({});
        const validateForm = () => {
        const newErrors = {};
    
        if (!formInfo.date) {
            newErrors.date = 'Обязательное поле';
        }
        
        if (formInfo.comment && (formInfo.comment.length < 2 || formInfo.comment.length > 300)) {
            newErrors.comment = 'Значение не может быть меньше 2 и более 300 символов';
        }
        if (formInfo.report && (formInfo.report.length < 2 || formInfo.report.length > 300)) {
            newErrors.report = 'Значение не может быть меньше 2 и более 300 символов';
        }

        if (!files.reports) {
            newErrors.report_files = 'Прикрепите файлы';
        }
    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const addData = () => {
        const formData = new FormData();

        formData.append('case_id', caseId);
        formData.append('date', normalizeDate(formInfo.date));
        formData.append('comment', formInfo.comment);
        formData.append('report', formInfo.report);
        formData.append('status', formInfo.status);

        if (files.reports && files.reports.length > 0) {
            files.reports.forEach((file) => {
                formData.append('file_reports', file);
            });
        }

        axios.put('/api/add-new-report', formData, {
            headers: {
            'Content-Type': 'multipart/form-data',
            },
        })
        .then(() => {
            setStatus(<a>Данные сохранены</a>);
            openTimeModal('Данные успешно сохранены', 'success');
            closeModal();
            onSuccess();
        })
        .catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>{error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        });
    };

    const changeData = () => {
        const token = localStorage.getItem('token');

        axios.put(`/api/change-report`, {
            id: formInfo.id,
            case_id: caseId,
            type: formInfo.type,
            applicant: formInfo.applicant,
            debtor_id: formInfo.debtor_id,
            case_id: formInfo.case_id,
            date: normalizeDate(formInfo.date),
            results: formInfo.results,
            actions: formInfo.actions,
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(() => {
            setStatus('Данные изменены');
            onSuccess();
            openTimeModal('Данные успешно изменены', 'success');
            closeModal();
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            if (action=='add') addData();
            if (action=='change') changeData();
        }
        setLoading(false);
    };

    const [files, setFiles] = React.useState({
        reports: null,
    });


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>
                        {action=='add' && 'Добавление'}{action=='change' && 'Редактирование'}
                        &nbsp;отчёта
                    </h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата собрания (комитета)</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input type='date' 
                                value={formInfo.date?.split('T')[0]}
                                onChange={handleChange('date')} 
                                className={errorsForm.date ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                disabled={loading}
                                required />
                                {errorsForm.date && <div className='errorUnderInput'>{errorsForm.date}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Повестка (комментарий)</a>
                        <div className='labelInputRight'>
                            <div>
                                <textarea 
                                    cols='10' 
                                    rows='10' 
                                    value={formInfo.comment}  
                                    onChange={handleChange('comment')}
                                    className={errorsForm.comment ? 'inputError' : ''}
                                    minLength='' 
                                    maxLength='300' 
                                    require=''
                                >
                                </textarea>
                                {errorsForm.comment && <div className='errorUnderInput'>{errorsForm.comment}</div>}
                                <p className='description'>{formInfo.comment.length}/300</p>
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Отчёт</a>
                        <div className='labelInputRight'>
                            <div>
                                <textarea 
                                    cols='10' 
                                    rows='10' 
                                    value={formInfo.report}  
                                    onChange={handleChange('report')}
                                    className={errorsForm.report ? 'inputError' : ''}
                                    minLength='' 
                                    maxLength='300' 
                                    require=''
                                >
                                </textarea>
                                {errorsForm.report && <div className='errorUnderInput'>{errorsForm.report}</div>}
                                <p className='description'>{formInfo.report.length}/300</p>
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Файлы</a>
                        <div className='labelInputRight'>
                            {action=='add' ? 
                                <div className='inputWrapper'>
                                    <FileUploadField
                                        label='Прикрепить файлы'
                                        file={files.reports}
                                        buttonLabel='Прикрепить файлы'
                                        onChange={(e) => setFiles(prev => ({ ...prev, reports: Array.from(e.target.files) }))}
                                        onReset={(indexToRemove) =>
                                            setFiles(prev => ({
                                                ...prev,
                                                reports: prev.reports.filter((_, i) => i !== indexToRemove),
                                            }))
                                        }
                                        allowMultiple={true}
                                    />
                                    {errorsForm.report_files && <div className='errorUnderInput'>{errorsForm.report_files}</div>}
                                </div>
                            :
                                <div className='panel'>
                                    <p className='description'>Изменение файла у существующей записи невозможно</p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <button 
                    type='button' 
                    className='button' 
                    onClick={handleSave}
                    disabled={loading}
                    >
                        {action=='add' && 'Добавить'} 
                        {action=='change' && 'Изменить'} 
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EditAccounting;